import React, { useEffect, useState } from "react";
import styled from "styled-components";
import logo from "../../images/logo-cliente-recurrente-pec.svg";
import { waLink, WA_MSG } from "./wa";

const scrollTo = (id) => (e) => {
  e.preventDefault();
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

const Bar = styled.header`
  position: sticky;
  top: 0;
  z-index: 50;
  width: 100%;
  background: ${(p) => (p.$scrolled ? "rgba(255, 255, 255, 0.85)" : "var(--bg)")};
  backdrop-filter: ${(p) => (p.$scrolled ? "blur(14px) saturate(150%)" : "none")};
  -webkit-backdrop-filter: ${(p) => (p.$scrolled ? "blur(14px) saturate(150%)" : "none")};
  border-bottom: 1px solid ${(p) => (p.$scrolled ? "var(--rule)" : "transparent")};
  transition: background 220ms ease, border-color 220ms ease;
`;

const Inner = styled.nav`
  max-width: 1240px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;

  @media (min-width: 768px) {
    padding: 1.1rem 2rem;
  }
`;

const Brand = styled.a`
  display: flex;
  align-items: center;
  gap: 0.65rem;
  text-decoration: none;
  color: var(--ink);

  img {
    width: 28px;
    height: 28px;
    display: block;
  }

  span {
    font-family: var(--sans);
    font-weight: 600;
    font-size: 1.02rem;
    letter-spacing: -0.012em;
    color: var(--ink);
  }
`;

const Links = styled.div`
  display: none;
  align-items: center;
  gap: 2.2rem;

  @media (min-width: 880px) {
    display: flex;
  }
`;

const NavLink = styled.a`
  font-family: var(--sans);
  font-size: 0.92rem;
  font-weight: 500;
  color: var(--ink-2);
  text-decoration: none;
  letter-spacing: -0.003em;
  transition: color 200ms ease;

  &:hover { color: var(--ink); }
`;

const Right = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const Cta = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-family: var(--sans);
  font-size: 0.92rem;
  font-weight: 500;
  background: var(--ink);
  color: #fff;
  text-decoration: none;
  padding: 11px 18px;
  border-radius: 999px;
  transition: background 200ms ease, transform 200ms cubic-bezier(0.2, 0, 0, 1);
  letter-spacing: -0.005em;
  white-space: nowrap;

  &:hover {
    background: var(--accent);
    transform: translateY(-1px);
  }

  svg {
    width: 12px;
    height: 12px;
  }
`;

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <Bar $scrolled={scrolled}>
      <Inner>
        <Brand href="/">
          <img src={logo} alt="" />
          <span>Cliente Recurrente</span>
        </Brand>

        <Links>
          <NavLink href="#como-funciona" onClick={scrollTo("como-funciona")}>Cómo funciona</NavLink>
          <NavLink href="#dashboard" onClick={scrollTo("dashboard")}>Dashboard</NavLink>
          <NavLink href="#industrias" onClick={scrollTo("industrias")}>Industrias</NavLink>
          <NavLink href="#faq" onClick={scrollTo("faq")}>Preguntas</NavLink>
        </Links>

        <Right>
          <Cta href={waLink(WA_MSG.demo)} target="_blank" rel="noreferrer">
            Agendar demo
            <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </Cta>
        </Right>
      </Inner>
    </Bar>
  );
}
